import React from 'react';
import {
    Checkbox as AntdCheckbox,
    type CheckboxChangeEvent,
    type CheckboxProps as AntdCheckboxProps,
    type CheckboxRef,
} from 'antd';
import type { CheckboxGroupProps } from 'antd/es/checkbox/Group';

export type CheckboxProps = AntdCheckboxProps;

type CheckboxComponent = React.ForwardRefExoticComponent<
    CheckboxProps & React.RefAttributes<CheckboxRef>
> & {
    Group: typeof AntdCheckbox.Group;
    __ANT_CHECKBOX?: boolean;
};

const Checkbox = React.forwardRef<CheckboxRef, CheckboxProps>((props, ref) => (
    <AntdCheckbox ref={ref} {...props} />
)) as CheckboxComponent;

Checkbox.displayName = 'Checkbox';
Checkbox.Group = (AntdCheckbox as typeof AntdCheckbox | undefined)
    ?.Group as typeof AntdCheckbox.Group;
Checkbox.__ANT_CHECKBOX = (
    AntdCheckbox as
        | (typeof AntdCheckbox & { __ANT_CHECKBOX?: boolean })
        | undefined
)?.__ANT_CHECKBOX;

export { AntdCheckbox };
export type { CheckboxChangeEvent, CheckboxGroupProps, CheckboxRef };
export default Checkbox;
